<template>
    <div></div>
</template>

<script>
export default {
    name: 'LoginAuto',
    data() {
        return {
            token: '',
        }
    },
    methods: {
        verificationToken() {
            this.axios.post('/api/login',{
                token: this.token,
            })
            .then(response=> {
                if(response.data.code == 0){
                    if(response.data.data.token!=''){
                        this.sessionData('set','token',response.data.data.token)
                        this.$router.push("/SendRecord")
                    }else{
                        this.$message.error(response.data.userTip)
                    }
                }else{
                    this.$router.push("/Login")
                    // if(response.data.code == 'A0200'){
                    //     this.$router.push("/Login")
                    // }
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
    },
    mounted: function() {
        this.token = this.$route.query.token
        this.verificationToken()
    }
}
</script>

<style scoped lang="less"> 

</style>
